import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { pts } from '../PTS';

export const usePTS = () =>
  useQuery({
    queryKey: [QUERY_KEYS.pts],
    queryFn: async () => (await pts.getPTSData()).data,
  });
